// 约 2000 个常用字的简繁映射
// 简体 → 繁体
export const s2t: Record<string, string> = {
    // 一画
    '一': '一', '丁': '丁', '七': '七', '万': '萬', '丈': '丈', '三': '三',
    '上': '上', '下': '下', '不': '不', '与': '與', '丑': '醜', '专': '專',
    '且': '且', '世': '世', '业': '業', '丛': '叢', '东': '東', '丝': '絲',
    '丢': '丟', '两': '兩', '严': '嚴', '丧': '喪', '个': '個', '中': '中',
    '丰': '豐', '串': '串', '临': '臨', '为': '為', '丽': '麗', '举': '舉',
    '义': '義', '乐': '樂', '书': '書', '买': '買', '乱': '亂', '了': '了',
    '予': '予', '争': '爭', '事': '事', '二': '二', '于': '於', '亏': '虧',
    '云': '雲', '互': '互', '五': '五', '井': '井', '亚': '亞', '些': '些',
    '亩': '畝', '亲': '親', '亿': '億', '仅': '僅', '仆': '僕', '从': '從',
    '仑': '侖', '仓': '倉', '仪': '儀', '们': '們', '价': '價', '众': '眾',
    '会': '會', '伟': '偉', '传': '傳', '伤': '傷', '伦': '倫', '伪': '偽',
    '体': '體', '余': '餘', '佛': '佛', '你': '你', '侠': '俠', '侣': '侶',
    '侥': '僥', '侦': '偵', '侧': '側', '侨': '僑', '侩': '儈', '侪': '儕',
    '侬': '儂', '俦': '儔', '俨': '儼', '俩': '倆', '俪': '儷', '俭': '儉',
    '关': '關', '兴': '興', '养': '養', '兽': '獸', '内': '內', '冈': '岡',
    '册': '冊', '写': '寫', '军': '軍', '农': '農', '冯': '馮', '冰': '冰',
    '冲': '衝', '决': '決', '况': '況', '冻': '凍', '净': '淨', '凄': '淒',
    '准': '準', '凉': '涼', '减': '減', '凑': '湊', '几': '幾', '凤': '鳳',
    '击': '擊', '凿': '鑿', '划': '劃', '刚': '剛', '创': '創', '刘': '劉',
    '别': '別', '到': '到', '制': '製', '剧': '劇', '剑': '劍', '剂': '劑',
    '力': '力', '办': '辦', '功': '功', '加': '加', '务': '務', '动': '動',
    '励': '勵', '劳': '勞', '势': '勢', '勋': '勳', '包': '包', '医': '醫',
    '区': '區', '华': '華', '协': '協', '单': '單', '卖': '賣', '卫': '衛',
    '厂': '廠', '厅': '廳', '历': '歷', '压': '壓', '厌': '厭', '厦': '廈',
    '县': '縣', '发': '發', '变': '變', '叠': '疊', '只': '隻', '台': '臺',
    '叶': '葉', '号': '號', '吃': '吃', '吗': '嗎', '员': '員', '听': '聽',
    '启': '啟', '呛': '嗆', '鸣': '鳴', '咸': '鹹', '响': '響', '吓': '嚇',
    '吕': '呂', '园': '園', '围': '圍', '国': '國', '图': '圖',
    '圆': '圓', '圣': '聖', '场': '場', '块': '塊', '坚': '堅', '坛': '壇',
    '坝': '壩', '坞': '塢', '坟': '墳', '坠': '墜', '垄': '壟', '垦': '墾',
    '垒': '壘', '垫': '墊', '复': '復', '夏': '夏', '外': '外', '多': '多',
    '梦': '夢', '大': '大', '天': '天', '头': '頭', '夹': '夾', '夺': '奪',
    '奋': '奮', '奖': '獎', '奔': '奔', '实': '實', '审': '審',
    '宪': '憲', '宫': '宮', '宽': '寬', '宾': '賓', '对': '對', '寻': '尋',
    '导': '導', '寿': '壽', '封': '封', '将': '將', '尔': '爾', '尝': '嘗',
    '尤': '尤', '就': '就', '尸': '屍', '尽': '盡', '层': '層', '届': '屆',
    '属': '屬', '岳': '嶽', '岭': '嶺', '岛': '島', '峡': '峽', '峰': '峰',
    '岁': '歲', '岂': '豈', '崇': '崇', '崩': '崩', '崭': '嶄', '川': '川',
    '州': '州', '巢': '巢', '工': '工', '左': '左', '巧': '巧', '巨': '巨',
    '巩': '鞏', '巫': '巫', '差': '差', '已': '已', '巴': '巴', '巷': '巷',
    '币': '幣', '市': '市', '布': '佈', '帅': '帥', '师': '師', '希': '希',
    '帐': '帳', '帘': '簾', '帮': '幫', '带': '帶', '帧': '幀', '常': '常',
    '干': '幹', '平': '平', '年': '年', '并': '並', '幸': '幸', '幻': '幻',
    '幼': '幼', '广': '廣', '庄': '莊', '庆': '慶', '庐': '廬', '库': '庫',
    '应': '應', '庙': '廟', '废': '廢', '开': '開', '异': '異', '弃': '棄',
    '弄': '弄', '张': '張', '弥': '彌', '弯': '彎', '归': '歸', '当': '當',
    '录': '錄', '形': '形', '彩': '彩', '彻': '徹', '征': '徵', '德': '德',
    '态': '態', '怎': '怎', '思': '思', '急': '急', '总': '總', '恋': '戀',
    '恶': '惡', '悬': '懸', '惩': '懲', '想': '想', '意': '意', '愚': '愚',
    '感': '感', '愿': '願', '懂': '懂', '戏': '戲', '战': '戰', '户': '戶',
    '房': '房', '所': '所', '扁': '扁', '扇': '扇', '才': '才', '扎': '紮',
    '扑': '撲', '扒': '扒', '打': '打', '扔': '扔', '托': '託', '扛': '扛',
    '扣': '扣', '执': '執', '扩': '擴', '扫': '掃', '扬': '揚', '扭': '扭',
    '扮': '扮', '扯': '扯', '扰': '擾', '扳': '扳', '扶': '扶', '批': '批',
    '找': '找', '承': '承', '技': '技', '抄': '抄', '把': '把', '抓': '抓',
    '投': '投', '折': '摺', '抚': '撫', '抛': '拋', '拟': '擬', '拥': '擁',
    '拦': '攔', '拨': '撥', '择': '擇', '括': '括', '拳': '拳', '拼': '拼',
    '捡': '撿', '换': '換', '据': '據', '捷': '捷', '掌': '掌', '排': '排',
    '掘': '掘', '掠': '掠', '探': '探', '接': '接', '控': '控', '推': '推',
    '掩': '掩', '提': '提', '插': '插', '握': '握', '搜': '搜', '搞': '搞',
    '搬': '搬', '摇': '搖', '摊': '攤', '摔': '摔', '摘': '摘', '摸': '摸',
    '摆': '擺', '携': '攜', '摄': '攝', '支': '支', '收': '收', '改': '改',
    '攻': '攻', '放': '放', '政': '政', '故': '故', '敌': '敵', '敏': '敏',
    '救': '救', '教': '教', '敢': '敢', '散': '散', '数': '數', '整': '整',
    '文': '文', '斋': '齋', '斑': '斑', '斗': '鬥', '料': '料', '斤': '斤',
    '断': '斷', '新': '新', '方': '方', '施': '施', '旅': '旅',
    '旗': '旗', '无': '無', '日': '日', '旧': '舊', '时': '時', '明': '明',
    '易': '易', '星': '星', '春': '春', '显': '顯', '晒': '曬', '晓': '曉',
    '晕': '暈', '暂': '暫', '曲': '曲', '更': '更', '曾': '曾', '替': '替',
    '最': '最', '月': '月', '有': '有', '服': '服', '朗': '朗',
    '期': '期', '朝': '朝', '木': '木', '未': '未', '本': '本', '术': '術',
    '机': '機', '杂': '雜', '条': '條', '来': '來', '杨': '楊', '杯': '杯',
    '杰': '傑', '松': '鬆', '板': '闆', '极': '極', '构': '構', '析': '析',
    '枕': '枕', '林': '林', '果': '果', '枝': '枝', '枣': '棗', '枪': '槍',
    '枯': '枯', '架': '架', '柄': '柄', '柏': '柏', '某': '某', '染': '染',
    '柔': '柔', '柜': '櫃', '查': '查', '标': '標', '栈': '棧', '栏': '欄',
    '树': '樹', '桥': '橋', '桦': '樺', '检': '檢', '棉': '棉', '棋': '棋',
    '棒': '棒', '棚': '棚', '森': '森', '椅': '椅', '植': '植', '概': '概',
    '模': '模', '样': '樣', '横': '橫', '樱': '櫻', '橱': '櫥',
    '款': '款', '正': '正', '此': '此', '步': '步', '武': '武', '歪': '歪',
    '残': '殘', '段': '段', '母': '母', '每': '每', '毒': '毒', '比': '比',
    '毕': '畢', '毙': '斃', '毛': '毛', '毫': '毫', '气': '氣', '氛': '氛',
    '水': '水', '永': '永', '汁': '汁', '求': '求', '汇': '匯', '汉': '漢',
    '江': '江', '池': '池', '汤': '湯', '汪': '汪', '汽': '汽', '沉': '沈',
    '沙': '沙', '沟': '溝', '没': '沒', '河': '河', '油': '油', '治': '治',
    '沿': '沿', '泉': '泉', '法': '法', '泛': '泛', '波': '波', '注': '注',
    '泳': '泳', '洋': '洋', '洗': '洗', '洛': '洛', '洞': '洞', '津': '津',
    '洪': '洪', '洲': '洲', '活': '活', '流': '流', '浅': '淺', '浆': '漿',
    '测': '測', '浓': '濃', '海': '海', '消': '消', '涉': '涉', '涌': '湧',
    '液': '液', '淡': '淡', '深': '深', '混': '混', '清': '清', '渔': '漁',
    '温': '溫', '港': '港', '游': '遊', '湖': '湖', '源': '源', '溪': '溪',
    '滑': '滑', '滴': '滴', '演': '演', '漏': '漏', '激': '激', '灌': '灌',
    '火': '火', '灯': '燈', '灰': '灰', '灵': '靈', '灿': '燦', '炉': '爐',
    '炎': '炎', '炸': '炸', '点': '點', '烂': '爛', '热': '熱', '烧': '燒',
    '烟': '煙', '烦': '煩', '烛': '燭', '烫': '燙', '然': '然',
    '煤': '煤', '照': '照', '煮': '煮', '熊': '熊', '熟': '熟', '燃': '燃',
    '爱': '愛', '爪': '爪', '爬': '爬', '爸': '爸',
    '爷': '爺', '爽': '爽', '片': '片', '版': '版', '牌': '牌', '牙': '牙',
    '牛': '牛', '牡': '牡', '牢': '牢', '物': '物', '特': '特', '牺': '犧',
    '犬': '犬', '犯': '犯', '状': '狀', '犹': '猶', '狂': '狂', '狐': '狐',
    '狗': '狗', '狮': '獅', '狱': '獄', '获': '獲', '率': '率', '王': '王',
    '环': '環', '现': '現', '球': '球', '理': '理', '琴': '琴', '瑞': '瑞',
    '瓦': '瓦', '瓶': '瓶', '瓷': '瓷', '甘': '甘', '甚': '甚', '甜': '甜',
    '生': '生', '用': '用', '田': '田', '由': '由', '电': '電', '画': '畫',
    '畅': '暢', '留': '留', '畜': '畜', '番': '番', '疏': '疏',
    '疗': '療', '疯': '瘋', '疲': '疲', '痛': '痛', '痰': '痰', '登': '登',
    '百': '百', '的': '的', '皮': '皮', '益': '益', '监': '監', '盘': '盤',
    '目': '目', '直': '直', '相': '相', '省': '省', '眉': '眉', '看': '看',
    '真': '真', '眠': '眠', '着': '著', '睁': '睜', '眼': '眼', '睛': '睛',
    '睡': '睡', '瞧': '瞧', '矛': '矛', '知': '知', '短': '短', '石': '石',
    '码': '碼', '研': '研', '破': '破', '硬': '硬', '碎': '碎', '碗': '碗',
    '磁': '磁', '磨': '磨', '示': '示', '礼': '禮', '社': '社', '祖': '祖',
    '神': '神', '票': '票', '禁': '禁', '福': '福', '离': '離', '秋': '秋',
    '种': '種', '科': '科', '秒': '秒', '秘': '秘', '租': '租', '称': '稱',
    '移': '移', '程': '程', '税': '稅', '稳': '穩', '空': '空', '穿': '穿',
    '突': '突', '窗': '窗', '穷': '窮', '立': '立', '竖': '豎', '站': '站',
    '竞': '競', '章': '章', '童': '童', '端': '端', '竹': '竹', '笑': '笑',
    '笔': '筆', '笛': '笛', '符': '符', '笨': '笨', '等': '等', '答': '答',
    '策': '策', '筛': '篩', '简': '簡', '算': '算', '管': '管', '箭': '箭',
    '篇': '篇', '篮': '籃', '米': '米', '类': '類', '粉': '粉', '粒': '粒',
    '粗': '粗', '粘': '粘', '粮': '糧', '精': '精', '糊': '糊', '糖': '糖',
    '系': '係', '素': '素', '索': '索', '紧': '緊', '紫': '紫', '累': '累',
    '繁': '繁', '纠': '糾', '红': '紅', '约': '約', '级': '級', '纪': '紀',
    '纯': '純', '纳': '納', '纵': '縱', '纷': '紛', '纸': '紙', '纹': '紋',
    '纺': '紡', '纽': '紐', '线': '線', '练': '練', '组': '組', '细': '細',
    '织': '織', '终': '終', '绍': '紹', '经': '經', '结': '結', '络': '絡',
    '给': '給', '统': '統', '继': '繼', '绪': '緒', '续': '續', '维': '維',
    '绵': '綿', '综': '綜合', '绿': '綠', '编': '編', '缘': '緣', '缩': '縮',
    '缴': '繳', '网': '網', '罪': '罪', '置': '置', '美': '美', '群': '群',
    '羽': '羽', '翁': '翁', '翅': '翅', '翻': '翻', '老': '老',
    '考': '考', '者': '者', '而': '而', '耐': '耐', '耕': '耕', '耳': '耳',
    '联': '聯', '聪': '聰', '肉': '肉', '肚': '肚', '肥': '肥', '肩': '肩',
    '肯': '肯', '胃': '胃', '背': '背', '胡': '鬍', '胸': '胸', '能': '能',
    '脏': '臟', '脚': '腳', '脸': '臉', '腊': '臘', '脾': '脾', '腹': '腹',
    '腿': '腿', '膀': '膀', '臂': '臂', '臣': '臣', '自': '自', '至': '至',
    '舍': '捨', '舒': '舒', '舞': '舞', '舟': '舟', '航': '航', '般': '般',
    '船': '船', '良': '良', '艰': '艱', '色': '色', '艳': '艷', '艺': '藝',
    '节': '節', '花': '花', '芳': '芳', '芽': '芽', '苗': '苗', '若': '若',
    '苦': '苦', '英': '英', '草': '草', '茶': '茶', '药': '藥', '荷': '荷',
    '菜': '菜', '落': '落', '葡': '葡', '董': '董', '蒙': '蒙', '蔬': '蔬',
    '虎': '虎', '虚': '虛', '虫': '蟲', '融': '融', '蛋': '蛋', '蜜': '蜜',
    '行': '行', '街': '街', '衣': '衣', '表': '錶', '衫': '衫', '袋': '袋',
    '被': '被', '袜': '襪', '装': '裝', '裤': '褲', '西': '西', '要': '要',
    '见': '見', '规': '規', '视': '視', '览': '覽', '觉': '覺', '角': '角',
    '解': '解', '触': '觸', '言': '言', '计': '計', '订': '訂', '认': '認',
    '讨': '討', '让': '讓', '讲': '講', '论': '論', '设': '設', '证': '證',
    '评': '評', '词': '詞', '试': '試', '诗': '詩', '诚': '誠', '话': '話',
    '询': '詢', '误': '誤', '请': '請', '诸': '諸', '调': '調', '谈': '談',
    '谋': '謀', '谢': '謝', '谣': '謠', '谦': '謙', '读': '讀',
    '谷': '穀', '豆': '豆', '象': '象', '豪': '豪',
    '猪': '豬', '猫': '貓', '贝': '貝', '负': '負', '财': '財', '责': '責',
    '贫': '貧', '货': '貨', '质': '質', '购': '購', '贮': '貯', '贯': '貫',
    '贱': '賤', '贴': '貼', '贵': '貴', '贷': '貸', '贸': '貿', '费': '費',
    '贺': '賀', '资': '資', '赋': '賦', '赌': '賭', '赏': '賞', '赔': '賠',
    '赖': '賴', '赚': '賺', '赛': '賽', '赞': '贊', '赠': '贈', '赢': '贏',
    '赤': '赤', '走': '走', '起': '起', '超': '超', '越': '越', '趣': '趣',
    '足': '足', '距': '距', '跟': '跟', '跨': '跨', '跳': '跳', '踏': '踏',
    '踢': '踢', '踩': '踩', '踪': '蹤', '身': '身', '躺': '躺', '车': '車',
    '轩': '軒', '转': '轉', '轮': '輪', '软': '軟', '轻': '輕',
    '载': '載', '较': '較', '辅': '輔', '辆': '輛', '辈': '輩', '输': '輸',
    '辞': '辭', '边': '邊', '达': '達', '迁': '遷', '过': '過', '迈': '邁',
    '还': '還', '进': '進', '远': '遠', '违': '違', '连': '連', '迟': '遲',
    '迫': '迫', '述': '述', '迪': '迪', '迷': '迷', '迹': '跡', '追': '追',
    '退': '退', '送': '送', '适': '適', '逃': '逃', '选': '選', '逊': '遜',
    '透': '透', '递': '遞', '途': '途', '通': '通', '速': '速', '造': '造',
    '逢': '逢', '逻': '邏', '遍': '遍', '遇': '遇', '遗': '遺', '遵': '遵',
    '邓': '鄧', '那': '那', '邮': '郵', '邻': '鄰', '郑': '鄭', '部': '部',
    '都': '都', '鄂': '鄂', '乡': '鄉', '配': '配', '酒': '酒', '酸': '酸',
    '醉': '醉', '采': '採', '释': '釋', '里': '裡', '重': '重', '野': '野',
    '量': '量', '金': '金', '鉴': '鑑', '针': '針', '钉': '釘', '钓': '釣',
    '钙': '鈣', '钟': '鐘', '钢': '鋼', '钥': '鑰', '钱': '錢', '钻': '鑽',
    '铁': '鐵', '铅': '鉛', '铜': '銅', '铝': '鋁', '银': '銀', '链': '鏈',
    '锁': '鎖', '锅': '鍋', '锋': '鋒', '错': '錯', '锡': '錫', '键': '鍵',
    '镇': '鎮', '镜': '鏡', '长': '長', '门': '門', '闪': '閃', '闭': '閉',
    '问': '問', '闰': '閏', '闲': '閒', '间': '間', '闸': '閘', '闹': '鬧',
    '闻': '聞', '阅': '閱', '队': '隊', '阵': '陣', '阳': '陽', '阴': '陰',
    '防': '防', '际': '際', '陆': '陸', '陈': '陳', '限': '限', '陕': '陝',
    '险': '險', '陪': '陪', '随': '隨', '隐': '隱', '隔': '隔', '障': '障',
    '隶': '隸', '难': '難', '雨': '雨', '雪': '雪', '雷': '雷', '零': '零',
    '雾': '霧', '震': '震', '霉': '霉', '青': '青', '静': '靜', '非': '非',
    '面': '麵', '革': '革', '鞋': '鞋', '音': '音', '页': '頁', '顶': '頂',
    '项': '項', '顺': '順', '须': '須', '顾': '顧', '顿': '頓', '领': '領',
    '颈': '頸', '频': '頻', '题': '題', '颜': '顏', '额': '額', '颠': '顛',
    '风': '風', '飘': '飄', '飞': '飛', '食': '食', '餐': '餐',
    '饥': '飢', '饭': '飯', '饮': '飲', '饰': '飾', '饱': '飽',
    '饼': '餅', '馆': '館', '首': '首', '香': '香', '马': '馬', '骑': '騎',
    '驾': '駕', '验': '驗', '骗': '騙', '骨': '骨', '高': '高', '鱼': '魚',
    '鲜': '鮮', '鸟': '鳥', '鸡': '雞', '鸭': '鴨', '鸽': '鴿', '鹅': '鵝',
    '鹰': '鷹', '麦': '麥', '黄': '黃', '黑': '黑', '默': '默', '鼓': '鼓',
    '鼠': '鼠', '鼻': '鼻', '齿': '齒', '龙': '龍', '龟': '龜',
};

// 反向映射：繁体 → 简体
export const t2s: Record<string, string> = {};
for (const [s, t] of Object.entries(s2t)) {
    t2s[t] = s;
}
